import createAPI from '../../common/helpers/create-api'

export default function addToast (Vue, Toast) {
  createAPI(Vue, Toast, ['timeout'], true)
}



// WEBPACK FOOTER //
// ./node_modules/cube-ui/src/modules/toast/api.js